import Transform from "@ember-data/serializer/transform";
import type { MedicalActFrequency } from "parog-web/models/medical-act-frequency-changed-journal-event";

interface SerializedMedicalActFrequency {
  medical_act: {
    procedure_source_label: string;
    procedure_source_concept?: string;
    procedure_source_value: string;
  };
  frequency: string;
  enabled: boolean;
}

export default class MedicalActFrequenciesTransform extends Transform {
  override deserialize(
    serialized: SerializedMedicalActFrequency[]
  ): MedicalActFrequency[] | undefined {
    if (serialized instanceof Array) {
      return serialized.map(elm => {
        return {
          medicalAct: {
            procedureSourceLabel: elm["medical_act"]["procedure_source_label"],
            procedureSourceConcept:
              elm["medical_act"]["procedure_source_concept"],
            procedureSourceValue: elm["medical_act"]["procedure_source_value"]
          },
          frequency: elm["frequency"],
          enabled: elm["enabled"]
        };
      });
    }
    return undefined;
  }

  override serialize(
    deserialized: MedicalActFrequency[]
  ): SerializedMedicalActFrequency[] | undefined {
    if (deserialized instanceof Array) {
      return deserialized.map(elm => {
        return {
          medical_act: {
            procedure_source_label: elm.medicalAct.procedureSourceLabel,
            procedure_source_concept: elm.medicalAct.procedureSourceConcept,
            procedure_source_value: elm.medicalAct.procedureSourceValue
          },
          frequency: elm.frequency,
          enabled: elm.enabled
        };
      });
    }
    return undefined;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "medical-act-frequencies": MedicalActFrequenciesTransform;
  }
}
